import React, { useEffect, useState } from "react"
import { GetTable } from "../../common/components/DataTable"
import { ClienteDto } from "../../generated"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import CustomersActions, { CustomersFilterData } from "../customersActions";
import { PageStore } from "../customersStore";
import { attach } from "../../common/componentExtensions";
import { CustomersFilter } from "./CustomersFilter";
import { CustomerCardSmall } from "./customerCard";
import { TabControl, TabItem } from "../../common/components/tabControl";
import { ImpiantiClienteTable } from "../../impianti/components/impiantiCliente";
import { InterventiCliente } from "../../interventi/components/InterventiCliente";
import { ImpiantoIcon, CustomerIcon } from "../../common/components/icons";
import { confirmMessage, messageAlert } from "../../common/components/confirm";
import { PhoneComponents } from "../../common/components/PhoneComponent";

const Table = GetTable<ClienteDto>();
export default attach((props: { data: ClienteDto[], filter: CustomersFilterData | null }) => {
    useEffect(() => {
        CustomersActions.submitFilter(props.filter ?? new CustomersFilterData())
    }, []);
    const [selectedItem, setSelectedItem] = useState<ClienteDto | null>(null);
    const onKeyDown = (e: React.KeyboardEvent) => {
        if (!selectedItem)
            return;
        if (e.key == "ArrowUp") {
            const index = props.data.indexOf(selectedItem);
            if (index == 0)
                return;
            setSelectedItem(props.data[index - 1]);
            e.preventDefault();
        }
        if (e.key == "ArrowDown") {
            const index = props.data.indexOf(selectedItem);
            if (index == props.data.length - 1)
                return;
            setSelectedItem(props.data[index + 1]);
            e.preventDefault();
        }
        if (e.key == "Escape") {
            if (selectedItem) {
                setSelectedItem(null);
                e.preventDefault();
            }
        }
    }

    const onDeleteCustomer = async (customer: ClienteDto) => {
        if (await confirmMessage(`Sei sicuro di voler eliminare il cliente ${customer.codiceClienteAzienda}?`, "Elimina cliente")) {
            let result = await CustomersActions.delete(customer.idCliente);
            if (!result.deleteOk) {
                messageAlert("Impossibile eliminare il cliente in quanto ci sono interventi effettuati.", "Elimina cliente")
            }
        }
    }

    return <div className="card">
        <div className="card-header bg-theme d-flex">
            <div className="flex-fill"><h3 className="text-white mb-0">Elenco Clienti</h3></div>
            <Link to={links.customerNew} className="btn btn-outline-secondary"><i className="fas fa-user-plus me-2" /> Aggiungi</Link>
        </div>
        <div className="card-body" >
            <CustomersFilter
                initialData={props.filter ?? new CustomersFilterData()}
                onSubmit={data => CustomersActions.submitFilter(data)}
            />
            <Table
                onKeyDown={onKeyDown}
                data={props.data}
                classNameSelector={x => x.dismessa ? "table-danger" : ""}
                keySelector={x => x.idCliente.toString()}
                filterables={[x => x.codiceClienteAzienda, x => x.azienda, x => x.cognomeProprietario, x => x.nomeProprietario, x => x.responsabile, x => x.indirizzo, x => x.telefono]}
                onRowClick={x => setSelectedItem(x == selectedItem ? null : x)}
            >
                <Table.SelectColumn
                    selectedItems={selectedItem ? [selectedItem] : []}
                    onSelectionChanged={items => setSelectedItem(items[items.length - 1])}
                />
                <Table.Column
                    header="Codice"
                    template={x =>
                        <Link to={links.customerShow(x.idCliente)}>
                            <CustomerIcon customer={x} /> {x.codiceClienteAzienda}
                        </Link>}
                    orderBy={x => x.codiceClienteAzienda}
                    groupBy={x => x.codiceClienteAzienda}
                />
                <Table.Column
                    header="Proprietario"
                    template={x => `${x.cognomeProprietario ?? ""} ${x.nomeProprietario ?? ""}`}
                />
                <Table.Column
                    header="Responsabile"
                    template={x => x.responsabile}
                />
                <Table.Column
                    header="Comune"
                    template={x => x.comune?.nomeComune}
                />
                <Table.Column
                    header="Indirizzo"
                    template={x => x.indirizzo}
                />
                <Table.Column
                    header="Telefono"
                    template={x => x.telefono && <PhoneComponents tel={x.telefono} />}
                />
                <Table.Column
                    header="Cell"
                    template={x => x.cell && <PhoneComponents tel={x.cell} showWhatsApp />}
                />
                <Table.Column
                    header="Email"
                    template={x => x.email ?? ""}
                    hidden
                />
            </Table>
            {selectedItem && <div className="d-none d-md-flex w-100 card sticky-top" style={{
                position: "sticky",
                bottom: 10,
                height: 350,
                background: "white",
                zIndex: 2,
            }}>
                <div className="w-100 card-body">
                    <TabControl>
                        <TabItem
                            name="baseData"
                            caption={
                                <div className="d-flex justify-content-center align-items-center">
                                    <i className="far fa-address-card fa-lg me-1" /> Dati anagrafici
                                </div>}>
                            <CustomerCardSmall id={selectedItem.idCliente} />
                        </TabItem>
                        <TabItem
                            name="impianti"
                            caption={
                                <div className="d-flex justify-content-center align-items-center">
                                    <ImpiantoIcon width={20} height={20} /> <span className="ms-1">Impianti</span>
                                </div>}>
                            <ImpiantiClienteTable
                                idCliente={selectedItem.idCliente}
                                style={{ maxHeight: 180 }}
                            />
                        </TabItem>
                        <TabItem
                            name="interventi"
                            caption={
                                <div className="d-flex justify-content-center align-items-center">
                                    <i className="fas fa-truck fa-lg me-1" /> Interventi
                                </div>}>
                            <InterventiCliente
                                idCliente={selectedItem.idCliente}
                                style={{ maxHeight: 180 }}
                            />
                        </TabItem>
                        {selectedItem.notaCliente && <TabItem name="notes"
                            caption={
                                <div className="d-flex justify-content-center align-items-center">
                                    <i className="far fa-sticky-note fa-lg me-1" /> Note
                                </div>}>
                            {selectedItem.notaCliente}
                        </TabItem>}
                    </TabControl>
                </div>
                <div className="card-footer">
                    <Link to={links.customerShow(selectedItem.idCliente)} className="btn btn-outline-secondary me-2">
                        <i className="fas fa-eye me-2" /> Apri
                    </Link>
                    <Link to={links.impiantoSelection(selectedItem.idCliente)} className="btn btn-outline-secondary me-2">
                        <i className="fas fa-plus" /> <ImpiantoIcon additionalClass="me-2" width={15} /> Nuovo Impianto
                    </Link>
                    <Link to={links.interventoNew({ idCliente: selectedItem.idCliente })} className="btn btn-outline-secondary me-2">
                        <i className="fas fa-plus" /> <i className="fas fa-truck" /> Nuovo Intervento
                    </Link>
                    <button className="btn btn-outline-danger me-2" onClick={() => onDeleteCustomer(selectedItem)}>
                        <i className="fas fa-user-times me-2" /> Elimina
                    </button>
                </div>
            </div>}
            {selectedItem && <div className="d-flex d-md-none w-100 card sticky-bottom" style={{
                background: "white",
                zIndex: 2,
            }}>
                <div className="card-footer d-flex flex-wrap justify-content-around">
                    <Link to={links.customerShow(selectedItem.idCliente)} className="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center" style={{ width: 52, height: 52 }}>
                        <h3 className="fas fa-eye" />
                        <span style={{ fontSize: "0.65em" }} className="text-truncate"> Apri</span>
                    </Link>
                    <Link to={links.impiantoSelection(selectedItem.idCliente)} className="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center" style={{ width: 52, height: 52 }}>
                        <div className="mb-1"><ImpiantoIcon width={19} /></div>
                        <span style={{ fontSize: "0.65em" }} className="text-truncate"><i className="fas fa-plus" /> Impianto</span>
                    </Link>
                    <Link to={links.interventoNew({ idCliente: selectedItem.idCliente })} className="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center" style={{ width: 52, height: 52 }}>
                        <h3 className="fas fa-truck" />
                        <span style={{ fontSize: "0.65em" }} className="text-truncate"><i className="fas fa-plus" /> Intervento</span>
                    </Link>
                    <Link to={links.interventi(selectedItem.idCliente)} className="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center" style={{ width: 52, height: 52 }}>
                        <h3 className="fas fa-eye" />
                        <span style={{ fontSize: "0.65em" }} className="text-truncate">Interventi</span>
                    </Link>
                    <button className="btn btn-outline-danger d-flex flex-column align-items-center justify-content-center" onClick={() => onDeleteCustomer(selectedItem)} style={{ width: 52, height: 52 }}>
                        <h3 className="fas fa-user-times text-danger" />
                        <span style={{ fontSize: "0.65em" }} className="text-truncate">Elimina</span>
                    </button>
                </div>
            </div>}
        </div>
    </div>

}, PageStore, store => ({ data: store.getall(), filter: store.getFilter() }));